/**
 * Best-effort form submission to the D1-backed endpoint (functions/api/submit.ts).
 * Never throws and never blocks the UI — the page shows its own confirmation
 * regardless, so the experience is unaffected if the endpoint is absent (local
 * dev) or down. `keepalive` lets the request survive a page navigation/redirect.
 */
export type SubmissionKind = "invitation" | "contact" | "newsletter";

export function recordSubmission(kind: SubmissionKind, data: Record<string, string>): void {
  try {
    void fetch("/api/submit", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ kind, ...data }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* fetch unavailable — ignore */
  }
}
